import script from "./DropChurchModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DropChurchModal.vue?vue&type=script&setup=true&lang=js"

import "./DropChurchModal.vue?vue&type=style&index=0&id=4dcddec0&lang=css"

const __exports__ = script;

export default __exports__